import { Injectable } from '@angular/core';

const BEARER_TOKEN_KEY = "bearer_token";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    constructor() {
    }

    get bearerToken(): string {
        return localStorage.getItem(BEARER_TOKEN_KEY) ?? localStorage.getItem("bearer-token") ?? "";
    }

    set bearerToken(token: string) {
        localStorage.setItem(BEARER_TOKEN_KEY, token);
    }
}